import DOMPurify from 'dompurify';

export function sanitizeInput(input: string): string {
  if (!input) {
    return input;
  }
  const stripped = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  const doc = new DOMParser().parseFromString(stripped, 'text/html');
  return doc.documentElement.textContent ?? '';
}
